import React, { Component } from 'react';
import { Button, Form, Input, message, Modal } from 'antd';
import { Message } from 'semantic-ui-react';

import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

const FormItem = Form.Item;
const TextArea = Input.TextArea;

class LicenseNoteModalDialog extends Component {
  componentDidUpdate() {
    const {
      addOrEditLicenseNoteActionStatus,
      loadLicenseNoteActionStatus,
    } = this.props;

    if (loadLicenseNoteActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadLicenseNoteActionStatus();
    }

    if (loadLicenseNoteActionStatus === ACTION_STATUS.ERROR) {
      message.error('Load License Note failed');
      this.props.initLoadLicenseNoteActionStatus();
    }

    if (addOrEditLicenseNoteActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Save License Note succeeded');
      this.props.initAddOrEditLicenseNoteActionStatus();
      this.props.resetLicenseNoteModal();
    }

    if (addOrEditLicenseNoteActionStatus === ACTION_STATUS.ERROR) {
      this.props.initAddOrEditLicenseNoteActionStatus();
    }
  }

  onInputChange = ({ name, value }) => {
    this.props.licenseNoteChangeInput({ name, value });
  };

  submitLicenseNote = () => {
    const { fields } = this.props.licenseNoteModal;
    this.props.form.validateFields(err => {
      if (!err) {
        this.props.addOrEditLicenseNote({
          id: fields.id,
          note: fields.note,
          mode: fields.id ? 'EDIT' : 'ADD',
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      licenseNoteModal,
      loadLicenseNoteActionStatus,
      addOrEditLicenseNoteActionStatus,
    } = this.props;
    const { isOpened, respErrMsg, fields } = licenseNoteModal;
    const isSubmitLoading = addOrEditLicenseNoteActionStatus === ACTION_STATUS.LOGINING;
    const isLoading = loadLicenseNoteActionStatus === ACTION_STATUS.LOGINING;

    return (
      <Modal
        title="License Note"
        centered
        width={720}
        visible={isOpened}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={this.props.resetLicenseNoteModal}
        footer={[
          <Button key="close" onClick={this.props.resetLicenseNoteModal}>
            Close
          </Button>,
          <Button key="submit" type="primary" loading={isSubmitLoading} onClick={this.submitLicenseNote}>
            Submit
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <FormItem label="Note">
            {getFieldDecorator('note', {
              initialValue: fields.note,
            })(
              <TextArea
                rows={8}
                disabled={isLoading}
                onChange={e => this.onInputChange({ name: 'note', value: e.target.value })}
              />
            )}
          </FormItem>
        </Form>
        {!!respErrMsg && (
          <Message negative>
            <Message.Header>Response Error Message</Message.Header>
            <p>{respErrMsg}</p>
          </Message>
        )}
      </Modal>
    );
  }
}

const LicenseNoteModalDialogForm = Form.create({ name: 'LicenseNoteModalDialog' })(LicenseNoteModalDialog);

export default LicenseNoteModalDialogForm;
